<template>
  <div>
    <b-row class="mb-1">
      <!-- search input -->
      <b-col>
        <section>
          <b-button
            v-b-modal.modal-filter-orders
            variant="outline-primary"
            class="d-flex"
          >
            <feather-icon icon="FilterIcon" />Filter
          </b-button>
        </section>
      </b-col>

      <b-col v-if="dataFiltered === true" class="d-flex justify-content-end">
        <xlsx-workbook>
          <xlsx-sheet
            v-for="sheet in sheets"
            :key="sheet.name"
            :collection="sheet.data"
            :sheet-name="sheet.name"
          />
          <xlsx-download>
            <b-button variant="primary" class="d-flex">
              <feather-icon icon="DownloadCloudIcon" /> Export
            </b-button>
          </xlsx-download>
        </xlsx-workbook>
      </b-col>
    </b-row>
    <b-tabs content-class="mt-4" align="center">
      <b-card title="Refund success Rate">
        <b-tab title="Group by Merchant">
          <b-row>
            <b-col>
              <b-table
                :items="reconciliations"
                :fields="fields"
                :filter="filter"
                :per-page="perPage"
                :current-page="currentPage"
                :responsive="true"
                outlined
                hover
                :foot-clone="dataFiltered && reconciliations.length > 0"
              >
                <!-- <template v-slot:reconciliations(paymentOptionLogoPath)="data">
                <b-avatar :src="data.item.paymentOptionLogoPath" />
              </template> -->

                <template v-slot:cell(date)="data">
                  <span>
                    {{
                      data.item.refundRequestedDate +
                      " - " +
                      data.item.refundRequestedEndDate
                    }}</span
                  >
                </template>

                <template #foot(merchantName)>
                  <strong>Total</strong>
                </template>

                <template #foot(date)>
                  <strong>{{ trxnDateRange }}</strong>
                </template>

                <template #foot(totalRefundRequests)>
                  <strong>{{
                    successRateSummary.totalRefundRequestsSum
                  }}</strong>
                </template>

                <template #foot(totalRefundRequestedAmount)>
                  <strong>{{
                    successRateSummary.totalRefundRequestedAmount
                  }}</strong>
                </template>

                <template #foot(pendingRefunds)>
                  <strong>{{ successRateSummary.pendingRefundsSum }}</strong>
                </template>

                <template #foot(approvedRefunds)>
                  <strong>{{ successRateSummary.approvedRefundsSum }}</strong>
                </template>

                <template #foot(sentRefunds)>
                  <strong>{{ successRateSummary.sentToBankRefundsSum }}</strong>
                </template>
                <template #foot(rejectedRefunds)>
                  <strong>{{ successRateSummary.rejectedRefundsSum }}</strong>
                </template>
                <template #foot(completedRefunds)>
                  <strong>{{ successRateSummary.completedRefundsSum }}</strong>
                </template>
                <template #foot(refundSuccessRate)>
                  <strong>{{
                    successRateSummary.averageRefundSuccessRate
                  }}</strong>
                </template>
              </b-table>
              <div class="d-flex justify-content-between flex-wrap">
                <div class="d-flex align-items-center mb-0 mt-1">
                  <span class="text-nowrap"> Showing 1 to &nbsp; </span>
                  <b-form-select
                    id="per-page-select"
                    v-model="perPage"
                    :options="[5, 10, 15, 20, { value: 100, text: 'Show all' }]"
                    size="sm"
                  ></b-form-select>
                  <span class="text-nowrap">
                    &nbsp; of {{ reconciliations.length }} entries
                  </span>
                </div>
                <div>
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                  />
                </div>
              </div>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab title="Group by FOP">
          <b-row>
            <b-col>
              <b-table
                :items="successRatePerPaymentOptions"
                :fields="fields2"
                :filter="filter"
                :per-page="perPage"
                :current-page="currentPage"
                :responsive="true"
                outlined
                hover
              >
                <!-- <template v-slot:reconciliations(paymentOptionLogoPath)="data">
                <b-avatar :src="data.item.paymentOptionLogoPath" />
              </template> -->

                <template v-slot:cell(date)="data">
                  <span> {{ trxnDateRange }}</span>
                </template>

                <template v-slot:cell(paymentOptionId)="data">
                  <span> {{ data.item.paymentOptionId }}</span>
                </template>
              </b-table>
              <div class="d-flex justify-content-between flex-wrap">
                <div class="d-flex align-items-center mb-0 mt-1">
                  <span class="text-nowrap"> Showing 1 to &nbsp; </span>
                  <b-form-select
                    id="per-page-select"
                    v-model="perPage"
                    :options="[5, 10, 15, 20, { value: 100, text: 'Show all' }]"
                    size="sm"
                  ></b-form-select>
                  <span class="text-nowrap">
                    &nbsp; of {{ successRatePerPaymentOptions.length }} entries
                  </span>
                </div>
                <div>
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="rows2"
                    :per-page="perPage"
                  />
                </div>
              </div>
            </b-col>
          </b-row>
        </b-tab>
      </b-card>
    </b-tabs>
    <div>
      <b-row>
        <b-col>
          <b-modal
            id="modal-filter-orders"
            title="Filter Refund success Rate"
            ok-title="Search"
            cancel-variant="outline-secondary"
            size="lg"
            @ok="filterOrders"
          >
            <b-form>
              <b-row style="height: 300px" class="overflow-auto">
                <b-col cols="8" class="mx-auto">
                  <b-form-group label="Merchants option" label-for="Merchants">
                    <v-select
                      multiple
                      v-model="selected"
                      :options="merchants"
                      label="name"
                    >
                      <template #option="option">
                        <span>{{ option.name }}</span>
                      </template>
                    </v-select>
                  </b-form-group>

                  <b-form-group label="Refund Date Range">
                    <flat-pickr
                      v-model="trxnDateRange"
                      class="form-control"
                      :config="{ mode: 'range', maxDate: 'today' }"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form>
          </b-modal>
        </b-col>
      </b-row>

      <!-- loadings -->
      <b-overlay :show="isLoading" no-wrap rounded="sm" />
    </div>
  </div>
</template>

<script>
import {
  BTabs,
  BTab,
  BAvatar,
  BCard,
  BButton,
  BBadge,
  BPagination,
  BOverlay,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormDatepicker,
  BRow,
  BCol,
  BForm,
  BTable,
  BCardText,
  BFormCheckbox,
  BLink,
  BDropdownItem,
  BDropdown,
  BFormCheckboxGroup,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import axios from "@axios";
import store from "@/store";
import flatPickr from "vue-flatpickr-component";
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
import XlsxSheet from "vue-xlsx/dist/components/XlsxSheet";
import XlsxDownload from "vue-xlsx/dist/components/XlsxDownload";
import XlsxWorkbook from "vue-xlsx/dist/components/XlsxWorkbook";

export default {
  components: {
    BTabs,
    BTab,
    BRow,
    BAvatar,
    BCol,
    BCard,
    VueGoodTable,
    BBadge,
    BButton,
    BOverlay,
    BPagination,
    BLink,
    BDropdownItem,
    BDropdown,
    BFormCheckboxGroup,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormDatepicker,
    flatPickr,
    BForm,
    BTable,
    BCardText,
    BCardActions,
    BFormCheckbox,
    vSelect,
    XlsxWorkbook,
    XlsxSheet,
    XlsxDownload,
  },
  data() {
    const nowDate = new Date();
    return {
      isLoading: false,
      dataFiltered: false,
      selectedOrderRefund: "",
      merchantIds: "",
      selected: [],
      merchants: [],
      filter: "",
      perPage: 10,
      currentPage: 1,
      pageLength: 5,
      isDeleteModel: false,
      dir: false,
      rangeDate: null,
      activeRow: null,
      extendedDate: `${nowDate.getUTCFullYear()}-${
        nowDate.getUTCMonth() + 1
      }-${nowDate.getUTCDate()}`,
      orderDateRange: "",
      trxnDateRange: "",
      isNotify: "",
      isNotified: "",
      VendorTxnRefNumber: "",
      orderStartDate: "",
      trxnStartDate: "",
      orderEndDate: "",
      trxnEndDate: "",
      orderFirstName: "",
      orderLastName: "",
      orderEmail: "",
      orderPhone: "",
      orderAmount: "",
      orderCurrency: "",
      orderCity: "",
      orderCountry: "",
      orderChannel: "",
      selectedOrder: "",
      filterOrderId: "",
      filterFopId: 0,
      filterFirstName: "",
      filterLastName: "",
      filtertrnxDate: "",

      paymentOptionLogoPath: "",
      paymentOption: "",
      transactionDate: "",
      transactionCount: 0,
      revenue: 0,
      marketSharePercentage: 0,

      fields: [
        "merchantName",
        { key: "date", label: "Date Range" },
        "totalRefundRequests",
        "totalRefundRequestedAmount",
        "pendingRefunds",
        "approvedRefunds",
        "sentRefunds",
        "rejectedRefunds",
        "completedRefunds",
        "refundSuccessRate",
      ],
      fields2: [
        "paymentOptionId",
        { key: "date", label: "Date Range" },
        "totalRefundRequests",
        "totalRefundRequestedAmount",
        "pendingRefunds",
        "approvedRefunds",
        "sentRefunds",
        "rejectedRefunds",
        "completedRefunds",
        "refundSuccessRate",
      ],

      paymentOptions: [{ value: 0, text: "--select Payment Option--" }],

      currencyOptions: [{ value: "ETB", text: "ETB" }],
      selectedCurrency: "ETB",
      searchTerm: "",
      editabelData: {},
      orderHistory: [],
      orderRefundHistory: [],
      orderHistories: [
        "paymentStatusDescription",
        "transactionDate",
        "actionTakenBy",
      ],

      // orderRefundHistories: ['level', 'actionDescription', 'transactionDate', 'actionTakenBy'],
      orderRefundHistories: [
        {
          key: "level",
          label: "Level",
        },
        {
          key: "actionDescription",
          label: "Action",
        },
        {
          key: "transactionDate",
          label: "Date",
        },
        {
          key: "actionTakenBy",
          label: "Action By",
        },
      ],
      referenceNumber: "",
      referenceState: null,
      selectedOrderCode: "",
      titleApprove: "",
      amount: 0,
      refundRequest: {
        orderCode: "",
        amount: 0,
        currency: "ETB",
        accountNumber: "",
        isRefundToSeparateAccountNumber: false,
      },
      successRatePerPaymentOptions: [],
      status: "monthly",
      monthlyPlanShow: true,
      pricing: {
        basicPlan: {
          title: "Basic",
          // eslint-disable-next-line global-require
          img: require("@/assets/images/illustration/Pot1.svg"),
          subtitle: "A simple start for everyone",
          monthlyPrice: 0,
          yearlyPlan: {
            perMonth: 0,
            totalAnual: 0,
          },
          planBenefits: [
            "100 responses a month",
            "Unlimited forms and surveys",
            "Unlimited fields",
            "Basic form creation tools",
            "Up to 2 subdomains",
          ],
          popular: false,
        },

        standardPlan: {
          title: "Standard",
          // eslint-disable-next-line global-require
          img: require("@/assets/images/illustration/Pot2.svg"),
          subtitle: "For small to medium businesses",
          monthlyPrice: 49,
          yearlyPlan: {
            perMonth: 40,
            totalAnual: 480,
          },
          planBenefits: [
            "Unlimited responses",
            "Unlimited forms and surveys",
            "Instagram profile page",
            "Google Docs integration",
            "Custom “Thank you” page",
          ],
          popular: true,
        },
        enterprisePlan: {
          title: "Enterprise",
          // eslint-disable-next-line global-require
          img: require("@/assets/images/illustration/Pot3.svg"),
          subtitle: "Solution for big organizations",
          monthlyPrice: 99,
          yearlyPlan: {
            perMonth: 80,
            totalAnual: 960,
          },
          planBenefits: [
            "PayPal payments",
            "Logic Jumps",
            "File upload with 5GB storage",
            "Custom domain support",
            "Stripe integration",
          ],
          popular: false,
        },
      },
      successRateSummary: null,
      reconciliations: [],
      ordersId: [],
      sheets: [
        { name: "Group by Merchant", data: [] },
        { name: "Group by FOP", data: [] },
      ],
    };
  },
  computed: {
    rows() {
      return this.reconciliations.length;
    },
    rows2() {
      return this.successRatePerPaymentOptions.length;
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        1: "light-success",
        0: "light-danger",
        /* eslint-enable key-spacing */
      };

      return (status) => statusColor[status];
    },
  },
  created() {
    this.fetchallPaymentOptions();
    this.fetchMerchant();
  },
  beforeCreate() {
    this.$http.get("/account-setting/data").then((res) => {
      this.options = res.data;
    });
  },
  methods: {
    fetchMerchant() {
      this.isLoading = true;
      axios
        .get("/Merchant/api/V1.0/Merchants/GetMerchants")
        .then((res) => {
          this.merchants = res.merchants;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    fetchallPaymentOptions() {
      this.isLoading = true;
      this.$store.dispatch("config/getActionPrivilege", "Order-View");
      axios
        .get(
          "/PaymentOptions/api/V1.0/PaymentOptions/FilterMerchantPaymentOptions?filterPaymentOption=0",
        )
        .then((res) => {
          res.paymentOptions.forEach((item) => {
            this.paymentOptions.push({
              value: item.id,
              text: item.name,
            });
          });
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    filterOrders() {
      this.selected.map((m) => {
        this.merchantIds += m.id + ",";
      });
      this.merchantIds = this.merchantIds.slice(0, -1);
      if (this.orderDateRange !== "") {
        const [orderSttDate, orderEdDate] = this.orderDateRange.split(" to ");

        if (this.orderDateRange.includes("to")) {
          this.orderStartDate = orderSttDate;
          this.orderEndDate = orderEdDate;
        } else {
          this.orderStartDate = this.orderDateRange;
          this.orderEndDate = this.orderDateRange;
        }
      }

      if (this.trxnDateRange !== "") {
        const [trxnSttDate, trxnEdDate] = this.trxnDateRange.split(" to ");
        // this.trxnEndDate = `${trxnEdDate.trim()}`
        // this.trxnStartDate = `${trxnSttDate.trim()}`

        if (this.trxnDateRange.includes("to")) {
          this.trxnStartDate = trxnSttDate;
          this.trxnEndDate = trxnEdDate;
        } else {
          this.trxnStartDate = this.trxnDateRange;
          this.trxnEndDate = this.trxnDateRange;
        }
      }

      const url = `/Order/api/V1.0/Report/RefundSuccessRateReport?refundRequestedStartDate=${this.trxnStartDate}&refundRequestedEndDate=${this.trxnEndDate}&merchantIds=${this.merchantIds}`;
      // Api call
      this.isLoading = true;
      axios
        .get(url)
        .then((res) => {
          this.sheets[0].data = [];
          this.sheets[1].data = [];
          this.reconciliations = res.refundSuccessRateResponses;
          this.successRateSummary = res.refundSuccessRateSummary;
          this.successRatePerPaymentOptions =
            res.refundSuccessRatePerPaymentOptions;
          this.sheets[0].data = res.refundSuccessRateResponses;
          this.sheets[0].data.forEach((item) => {
            delete item.merchantId;
          });
          this.sheets[1].data = res.refundSuccessRatePerPaymentOptions;
          this.sheets[1].data.forEach((item) => {
            item.paymentOptionId = this.paymentOptions.filter(
              (paymentOption) => paymentOption.value == item.paymentOptionId,
            )[0].text;
          });

          this.dataFiltered = true;
          this.isLoading = false;
          this.merchantIds = "";
          this.trxnEndDate = "";
          this.trxnStartDate = "";
        })
        .catch((res) => {
          this.isLoading = false;
          this.reconciliations = [];
          this.merchantIds = "";
          this.sheets[0].data = [];
          this.sheets[1].data = [];
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              icon: "BellIcon",
              variant: "danger",
              text: `${res.data.message}`,
            },
          });
          // this.$refs.loginForm.setErrors(error)
          this.orderStartDate = "";
          this.orderEndDate = "";
          this.trxnEndDate = "";
          this.trxnStartDate = "";
        });
    },

    resetModal() {
      this.referenceNumber = "";
      this.referenceState = null;
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>

<style lang="scss">
@import "@core/scss/vue/pages/page-pricing.scss";
</style>
